export default __webpack_public_path__ + "static/media/trash.611e0296.svg";